import { render, staticRenderFns } from "./WorkShow.vue?vue&type=template&id=d3990d16&scoped=true&"
import script from "./WorkShow.vue?vue&type=script&lang=js&"
export * from "./WorkShow.vue?vue&type=script&lang=js&"
import style0 from "./WorkShow.vue?vue&type=style&index=0&id=d3990d16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3990d16",
  null
  
)

export default component.exports